export function h(tag, attrs, children) {
	const el = document.createElement(tag);

	if (attrs) {
		for (const key in attrs) {
			if (key === 'class') {
				el.className = attrs[key];
			} else if (key === 'html') {
				el.innerHTML = attrs[key];
			} else if (key.startsWith('on') && typeof attrs[key] === 'function') {
				el.addEventListener(key.slice(2).toLowerCase(), attrs[key]);
			} else if (attrs[key] !== undefined && attrs[key] !== null && attrs[key] !== false) {
				el.setAttribute(key, attrs[key]);
			}
		}
	}

	const kids = Array.isArray(children) ? children : children != null ? [children] : [];
	for (const kid of kids) {
		if (kid == null || kid === false) continue;
		el.appendChild(kid instanceof Node ? kid : document.createTextNode(String(kid)));
	}

	return el;
}

export function clear(el) {
	while (el.firstChild) el.removeChild(el.firstChild);
}

export function escapeHtml(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function highlightMatch(text, query) {
	if (!query) return escapeHtml(text);
	const escaped = escapeHtml(text);
	const safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	return escaped.replace(new RegExp('(' + safeQuery + ')', 'ig'), '<mark>$1</mark>');
}
